(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"), require("jQuery"));
	else if(typeof define === 'function' && define.amd)
		define([, "jQuery"], factory);
	else if(typeof exports === 'object')
		exports["vue-giant-tree3"] = factory(require("vue"), require("jQuery"));
	else
		root["vue-giant-tree3"] = factory(root["Vue"], root["jQuery"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__203__, __WEBPACK_EXTERNAL_MODULE__145__) {
return 